import React, { useState, useEffect } from 'react';
import './PhotoHighlights.css';

interface PhotoHighlight {
  image: string;
  header: string;
  body: string;
}

const photos: PhotoHighlight[] = [
  { 
    image: './blue-truck.jpg', 
    header: 'Transport rapid și sigur', 
    body: 'Marfa ta livrată la timp, oriunde în țară.' 
  },
  { 
    image: './imagine-teren.jpg', 
    header: 'Cereale de calitate pentru afacerea ta', 
    body: 'Grâu, porumb, orz, rapiță, floarea-soarelui și soia.' 
  },
  {
    image: './imagine-excavator.jpg',
    header: "Agregate pentru proiectul\xa0tău",
    body: 'Te susținem în toate etapele lucrării.'
  }
];

const PhotoHighlights: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
    }, 5000); // Change photo every 5 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="photo-highlight">
      {photos.map((photo, index) => (
        <div
          key={index}
          className={`photo-slide ${index === currentIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${photo.image})` }}
        >
          <div className="photo-highlight-overlay">
            <h1 className="photo-highlight-header">{photo.header}</h1>
            <p className="photo-highlight-body">{photo.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PhotoHighlights;
